import React, { useEffect } from 'react';
import Portal from './Portal';

interface InfoPopupProps {
  reason: string;
  onClose: () => void;
}

const InfoPopup: React.FC<InfoPopupProps> = ({ reason, onClose }) => {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  return (
    <Portal>
      <div className="modal show d-block" style={{ backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)' }} tabIndex={-1} onClick={onClose}>
        <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
            <div className="modal-header border-bottom-0 pt-4 px-4">
              <div className="d-flex align-items-center">
                <div className="bg-primary bg-opacity-10 p-2 rounded-3 me-3">
                  <i className="bi bi-info-circle text-primary fs-5"></i>
                </div>
                <h5 className="modal-title fw-bold mb-0">Information</h5>
              </div>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body px-4 pb-4">
              <div className="bg-light p-3 rounded-3">
                <p className="mb-0 text-dark" style={{ whiteSpace: 'pre-wrap' }}>{reason}</p>
              </div>
            </div>
            <div className="modal-footer border-top-0 px-4 pb-4 pt-0">
              <button type="button" className="btn btn-primary w-100 fw-bold py-2" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default InfoPopup;